import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";

export default class DoctorService extends MainService {


    static listAllPagination(params) {
        return this.postSEC(ServiceConstant.DOCTOR_LIST_ALL_PAGINATION, params)
    }

    static listAll() {
        return this.postSEC(ServiceConstant.DOCTOR_LIST_ALL);
    }

    static get({idDoctor}) {
        return this.postSEC(ServiceConstant.DOCTOR_GET, {idDoctor});
    }

    static add(params) {
        return this.postSEC(ServiceConstant.DOCTOR_ADD, params);
    }

    static update(params) { 
        return this.postSEC(ServiceConstant.DOCTOR_UPDATE, params);
    }

    static delete({idDoctor}) {
        return this.postSEC(ServiceConstant.DOCTOR_DELETE, {idDoctor});
    }

}
